<template>
    <ul>
        <li class="form-label">
            {{ $t('Expected Call Success Rate') }}
        </li>
        <li class="inline-form-item">
            <cic-textbox
                id="profile_successRate"
                :enabled="editing"
                :value="item.successRate"
                :int-only="true"
                @input="(val) => updateFieldValue('successRate', val)"
            />
            <span>%</span>
        </li>
        <li class="form-label">
            {{ $t('Expected Call Handling Time') }}
        </li>
        <li>
            <edit-duration
                id="profile_handlingTime"
                :enabled="editing"
                :value="item.handlingTime"
                @input="(val) => updateFieldValue('handlingTime', val)"
            />
        </li>
    </ul>
</template>

<script>
    import CicTextbox from '@/components/inputs/CicTextbox';
    import EditDuration from './EditDuration';

    export default {
        name: 'EditPredictive',
        components: {
            CicTextbox,
            EditDuration,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['input'],
        methods: {
            updateFieldValue(field, val) {
                this.$emit('input', field, val);
            },
        },
    };
</script>
